import axios from 'axios';

export default {
  newAddress,
  getAllAddressesByCustomerId,
  getRegionsByCountry,
  getSubscriptionsWithItemsByAddressId,
  saveAddress,
  deleteAddress,
  validateAddress,
  zipCheck
};

export function newAddress() {
  return axios.get('/api/customer/newAddress');
}

export function getAllAddressesByCustomerId() {
  return axios.get('/api/customer/getAllAddressesByCustomerId');
}

export function getRegionsByCountry(params) {
  return axios.get('/api/appLookup/getRegionsByCountry', { params });
}

export function getSubscriptionsWithItemsByAddressId(params) {
  return axios.get('/api/subscription/getSubscriptionsWithItemsByAddressId', { params });
}

export function saveAddress(params) {
  return axios.post('/api/customer/addOrUpdateAddress', params);
}

export function deleteAddress(params) {
  return axios.post('/api/customer/deleteAddress', params);
}

export function validateAddress(params) {
  return axios.post('/api/customer/validateAddressViaUsps', params);
}

export function zipCheck(zip) {
  return axios.get('/api/usps/zipCheck', { params: { zip }});
}
